import { BaseWebComponentDataProvider } from '../../../../../framework/BaseWebComponentDataProvider';
import {
  AUTH_VALUES,
  AuthTypesData,
  CredentialsManagerCreateRequest,
  CredentialsManagerCreateResponse,
  CredentialsManagerGridSchema,
  UploadFileResponse,
} from '../types';
import { ConsoleRequest, DataProviderType } from '../../../../../utils/request';
import { BaseWebComponentTranslator } from '../../../../../framework/BaseWebComponentTranslator';

const ENDPOINT = 'Credentials';

export class CredentialsManagerGridBaseDataProvider extends BaseWebComponentDataProvider {
  private stringsTranslator: BaseWebComponentTranslator = BaseWebComponentTranslator.getInstance();

  public async createRecords(request: CredentialsManagerCreateRequest): Promise<CredentialsManagerCreateResponse> {
    return ConsoleRequest.createRequest<CredentialsManagerCreateResponse>({
      dataProviderType: DataProviderType.CORE,
      payload: {
        records: [request],
      },
      endpoint: ENDPOINT,
      method: 'createRecords',
    });
  }

  public async removeRecords(request: CredentialsManagerGridSchema): Promise<CredentialsManagerCreateResponse> {
    return ConsoleRequest.createRequest<CredentialsManagerCreateResponse>({
      dataProviderType: DataProviderType.CORE,
      payload: {
        records: [request],
      },
      endpoint: ENDPOINT,
      method: 'removeRecords',
    });
  }

  public getAuthTypes(): AuthTypesData[] {
    return [
      {
        value: AUTH_VALUES.PASSWORD,
        title: this.stringsTranslator.getAuthTypes(AUTH_VALUES.PASSWORD),
      },
      {
        value: AUTH_VALUES.PEM_FILE,
        title: this.stringsTranslator.getAuthTypes(AUTH_VALUES.PEM_FILE),
      },
    ];
  }

  public async uploadFile(url: string, form: FormData): Promise<UploadFileResponse> {
    const response: Response = await fetch(url, {
      method: 'POST',
      body: form,
    });

    return await response.json();
  }
}
